import { FC, useEffect, useRef } from 'react'
import lottie from 'lottie-web'
import { LottieProps as Props } from './types'

const LottiePlayer: FC<Props> = ({ animationData, isHovered }) => {
  const element = useRef<HTMLDivElement>(null)
  const lottieInstance = useRef<any>()

  useEffect(() => {
    if (animationData && element.current) {
      lottieInstance.current = lottie.loadAnimation({
        animationData,
        container: element.current,
        autoplay: false
      })

      return () => {
        lottie.destroy()
      }
    }
  }, [animationData])

  useEffect(() => {
    if (isHovered && lottieInstance.current) {
      lottieInstance.current.play()
    }

    if (!isHovered && lottieInstance.current) {
      lottieInstance.current.goToAndStop(0)
    }
  }, [isHovered])

  return <div ref={element} style={{ height: '100%', width: '100%' }} />
}

export default LottiePlayer
